import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Prefixs } from "../../../../Constant";
import PrefixForm from "./PrefixForm";

const Prefix = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={Prefixs} />
        <CardBody className="mt-3 mb-3">
          <PrefixForm />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Prefix;
